<app-select-box
  class="select"
  [(opened)]="opened"
  [dataSource]="dataSource"
  [searchEnabled]="true"
  [openOnInputClick]="false"
  [keepSearchTextEnabled]="true"
  [searchDebounce]="searchDebounce"
  [minSearchLength]="3"
  [showErrorEnabled]="false"
  [showOpenedIndicatorButton]="false"
  displayExpr="text"
  valueExpr="key"
  placeholder="{{ this.ts.getCurrentLanguage()['go-to'] }}"
  (onItemSelected)="onItemSelectedInternal($event)"
  (onSearchValueChanged)="onSearchValueChanged($event)"
  (onKeydown)="onKeydown($event)"
>
  <app-button
    [ngClass]="isMobileScreen && 'button-mobile'"
    *ngIf="!(searchLoading.changes | async)"
    appFieldSuffix
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    sizeType="x-small"
    icon="assets/icons/search.svg"
    (click)="onBtnSearchClick()"
  ></app-button>

  <app-loading-indicator
    *ngIf="searchLoading.changes | async"
    appFieldSuffix
    class="loading-indicator"
  ></app-loading-indicator>
</app-select-box>
